import "../Cash";
import $ from "cash-dom";
import { Sorting } from "./sorting";

let isGeo = $(".sortby__btn, .sortby-mobile").data("geo");
let sorting = new Sorting(isGeo);

console.time("filters");
console.log("initialize filters");
sorting.initializeFilters();

$(".sortby__btn, .sortby-mobile").on("change", (event) => {
  let params = new URLSearchParams($(event.target).val().toString());
  sorting.sortBy(params);
});

$(".api-filter").on("change", (event) => {
  if (!$(".left-rail").hasClass("is-hidden-touch")) {
    toggleMobileFilters();
  }
  sorting.filter(
    $(event.target).attr("name"),
    $(event.target).val().toString()
  );
});

$(".checkbox-filters").on("click", (event) => {
  let fieldName = $(event.target).attr("name");
  sorting.clearFilter(fieldName);
  $(`input[name="${fieldName}"]:checked`).each((key, value) => {
    sorting.addFilter(fieldName, $(value).val().toString(), true);
  });
  if (!$(".left-rail").hasClass("is-hidden-touch")) {
    toggleMobileFilters();
  }
  sorting.filter();
});

$(".radio-filter").on("change", (event) => {
  $(".radio-filter:checked").each((key, value) => {
    sorting.addFilter($(event.target).attr("name"), $(value).val().toString());
    sorting.filter();
  });
  if (!$(".left-rail").hasClass("is-hidden-touch")) {
    toggleMobileFilters();
  }
});

$("#make-selector").on("change", (event) => {
  sorting.redirectTo("make", [$(event.target).val().toString()]);
});

$("#model-selector").on("change", (event) => {
  sorting.redirectTo("model", [$(event.target).val().toString()]);
});

$("#min-year, #max-year").on("change", (event) => {
  if (!$(".left-rail").hasClass("is-hidden-touch")) {
    toggleMobileFilters();
  }
  sorting.filter(
    $(event.target).attr("name"),
    $(event.target).val().toString()
  );
});

const filterForms = $(".left-rail-form");
for (let i = 0; i < filterForms.length; i++) {
  $(filterForms[i]).on("submit", (e) => {
    e.preventDefault();
    let form = $(e.target);
    let inputlist = $(filterForms[i]).find("input");
    inputlist.each((index, element) => {
      let name = $(element).attr("name");
      if (name == "zip" && !isValidZipCode($(element).val())) {
        displayError(form, $(element));
      } else {
        hideError(form, $(element));
        if (!$(".left-rail").hasClass("is-hidden-touch")) {
          toggleMobileFilters();
        }
        sorting.addFilter($(element).attr("name"), $(element).val().toString());
      }
    });
    sorting.filter();
  });
}

$(".filter-header").on("click", (event) => {
  let target = $(event.currentTarget);
  target.children(".bulma-arrow-mixin").toggleClass("is-open");
  target.siblings(".field").toggleClass("is-hidden");
});

$(".close-btn, .filter-results").on("click", () => {
  toggleMobileFilters();
});

function toggleMobileFilters() {
  $(".left-rail").toggleClass("is-hidden-touch");
  $(".mobile-filtering").toggleClass("close-mobile-filtering");
  $(".close-btn").toggleClass("is-hidden");
  $(".mobile-filtering-menu").toggleClass("is-hidden");
}

function isValidZipCode(zipCode) {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode);
}

function displayError(form, input) {
  form.addClass("error");
  input.addClass("is-danger");
  form.find(".help").removeClass("is-hidden");
}

function hideError(form, input) {
  form.removeClass("error");
  input.removeClass("is-danger");
  form.find(".help").addClass("is-hidden");
}

// Fill Year Dropdowns
let minYear = $("#min-year");
let maxYear = $("#max-year");
let currentMinYear = minYear.data("min-year");
let currentMaxYear = maxYear.data("max-year");
let earliestYear = 1998;
let latestYear = 2024;

for (var i = latestYear; i >= earliestYear; i--) {
  let minOption = document.createElement("option");
  minOption.text = i.toString();
  minOption.value = i.toString();
  let maxOption = minOption.cloneNode(true);
  if (i == currentMinYear) {
    $(minOption).attr("selected", "selected");
  }
  if (i == currentMaxYear) {
    $(maxOption).attr("selected", "selected");
  }
  minYear.append(minOption);
  maxYear.append(maxOption);
}
